import { FETCH_CALL_LOGS_LOADING, FETCH_CALL_LOGS_SUCCESS, FETCH_CALL_LOGS_FAILED, FETCH_CALL_LOGS_PAGINATE_SUCCESS, FETCH_CALL_LOGS_FILTERED_LOADING, FETCH_CALL_LOGS_FILTERED_SUCCESS, CLEAR_CALL_LOGS_STATUS, CLEAR_CALL_LOGS_DETAILS } from '../actions/soundManager.action';
import { CallLogsReducer } from '../models/callLogs.interface';

const initialState: CallLogsReducer = {
    callLogsLoading: true,
    callLogsError: false,
    callLogsMessage: "",
    callLogsData: [],
    saveLoading: false,
    total: 0,
    totalLogs: 0,
    filteredLoading: false,
    creditCurrency: '',
    enableConversation: '0',
    enableMasking: 0
}

const callLogsReducer = (state: CallLogsReducer = initialState, action: any): CallLogsReducer => {
    switch (action.type) {

        case CLEAR_CALL_LOGS_STATUS:
            return {
                ...state,
                callLogsError: false,
                callLogsMessage: ""
            }
        case FETCH_CALL_LOGS_LOADING:
            return {
                ...state,
                callLogsLoading: true,
                callLogsError: false,
                callLogsMessage: ""
            }
        case FETCH_CALL_LOGS_SUCCESS:
            return {
                ...state,
                callLogsLoading: false,
                callLogsData: action.payload.data,
                total: action.payload.total,
                totalLogs: action.payload.total,
                creditCurrency: action.payload.currency_symbol,
                enableConversation: action.payload.enable_conversation || '0',
                enableMasking: action.payload.enable_masking || 0,
            }
        case FETCH_CALL_LOGS_FAILED:
            return {
                ...state,
                callLogsLoading: false,
                filteredLoading: false,
                callLogsError: true,
                callLogsMessage: action.payload.error.message || ""
            }
        case FETCH_CALL_LOGS_PAGINATE_SUCCESS:
            return {
                ...state,
                callLogsLoading: false,
                callLogsError: false,
                filteredLoading: false,
                callLogsData: [...state.callLogsData, ...action.payload.data],
                creditCurrency: action.payload.currency_symbol || '',
                enableConversation: action.payload.enable_conversation || '0',
                enableMasking: action.payload.enable_masking || 0,
            }
        case FETCH_CALL_LOGS_FILTERED_LOADING:
            return {
                ...state,
                filteredLoading: true
            }

        case FETCH_CALL_LOGS_FILTERED_SUCCESS:
            return {
                ...state,
                filteredLoading: false,
                callLogsData: [...action.payload.data],
                total: action.payload.total,
            }
        case CLEAR_CALL_LOGS_DETAILS:
            return initialState;
        default:
            return state;
    }
}

export default callLogsReducer;